import React, { useState } from "react";
import api from "../../api";
import { DropdownList } from "react-widgets";
import AutoCompleteInput from "../../components/form-group/auto-complete-input";
import DateInput from "../../components/form-group/date-input";
interface Filters {
  eventType?: string;
  userId?: string;
  fromDate?: string;
  toDate?: string;
  target?: string;
  filterBy?: string;
}

const ListFilter: React.FunctionComponent<{
  hideFilter: () => void;
  onFilter: (filter: Filters) => void;
  filterBy: string;
}> = (props) => {
  const [filters, setFilters] = useState<Filters>();

  const clearFilter = () => {
    setFilters({});
    props.onFilter?.({});
    props.hideFilter();
  };

  const applyFilters = (key: string, value: string | Date) => {
    const newFilter: Filters = {
      ...filters,
      [key]: value,
    };

    setFilters(newFilter);
    props.onFilter?.(newFilter);
  };

  return (
    <div className="border-bottom p-3">
      <div className="form-group font-weight-semibold mb-2">
        <DropdownList
          data={[
            { label: "Create", value: "create" },
            { label: "Update", value: "update" },
            { label: "Delete", value: "delete" },
          ]}
          textField={"label"}
          valueField={"value"}
          placeholder={"Select Type"}
          onChange={(val) => applyFilters("eventType", val.value)}
        />
      </div>
      {/* After merging two log components, uncomment this */}
      {/* <div className="form-group font-weight-semibold mb-2">
        <AutoCompleteInput
          placeholder={'Support Executive'}
          onChange={(val) => applyFilters('userId', val?._id || '')}
          apiUrl="api/user/crm-agents"
          valueField={'name'}
        />
      </div> */}
      {props.filterBy === "target" && (
        <div className="form-group font-weight-semibold mb-2">
          <DropdownList
            data={[
              { label: "Lead", value: "lead" },
              { label: "Customer", value: "customer" },
            ]}
            textField={"label"}
            valueField={"value"}
            placeholder={"Select Target"}
            onChange={(val) => applyFilters("target", val.value)}
          />
        </div>
      )}
      {props.filterBy === "Lead Settings" && (
        <div className="form-group font-weight-semibold mb-2">
          <DropdownList
            data={[
              { label: "Lead Intent", value: "Lead Intent" },
              { label: "Lead Type", value: "Lead Type" },
              { label: "Lead Status", value: "Lead Status" },
              { label: "Lead Newness", value: "Lead Newness" },
              { label: "Initial Touch Point", value: "Initial Touch Point" },
              { label: "Source of Business", value: "Source of Business" },
              {
                label: "Need Profile Management",
                value: "Need Profile Management",
              },
              {
                label: "Buying Influence Mapping",
                value: "Buying Influence Mapping",
              },
              { label: "Lead Quality", value: "Lead Quality" },
              { label: "Lead Quality Reason", value: "Lead Quality Reason" },
              { label: "Bank", value: "Bank" },
            ]}
            textField={"label"}
            valueField={"value"}
            placeholder={"Select Lead Settings"}
            onChange={(val) => applyFilters("filterBy", val.value)}
          />
        </div>
      )}

      <div className="form-group font-weight-semibold mb-2">
        <DateInput
          placeholder={"From Date"}
          onChange={(val: Date) => applyFilters("fromDate", val.toISOString())}
        />
      </div>
      <div className="form-group font-weight-semibold mb-2">
        <DateInput
          placeholder={"To Date"}
          onChange={(val: Date) => applyFilters("toDate", val.toISOString())}
          minDate={filters?.fromDate ? new Date(filters?.fromDate) : new Date()}
        />
      </div>
      <div className="pt-2 mb-2 text-right">
        <button
          type="reset"
          className="text-gray-400 btn p-0 font-normal mr-3 text-decoration-underline font-weight-semibold"
          onClick={clearFilter}
        >
          Clear Filter
        </button>
        <button
          type="button"
          className="text-primary font-weight-bold btn p-0 font-normal"
          onClick={props.hideFilter}
        >
          Hide Filter
        </button>
      </div>
    </div>
  );
};

export default ListFilter;
